import * as React from 'react'

const Chevron = ({className}) => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" 
                viewBox="0 0 15.567 9.081" className={'docs-icon ' + className}>
                    <path d="M13.918,0,7.784,5.906,1.649,0,0,1.588,7.784,9.081l7.784-7.493Z"></path>
            </svg>);
}

export default Chevron;